import { observable, action/* , computed */ } from 'mobx';
import { fileController } from 'Components/viewer/Controllers/index';
import { storageGetItem, storageSetItem } from '@/utils/utils';
import { store } from 'Store/store.index';

const oldTemplate = require('../../src/components/dialogs/Compare/assets/old summary.pdf');
const newTemplate = require('../../src/components/dialogs/Compare/assets/new summary.pdf');

const formPreference = JSON.parse(storageGetItem(localStorage, 'formPreference'));
const layoutPreference = JSON.parse(storageGetItem(localStorage, 'layoutPreference'));
const searchPreference = JSON.parse(storageGetItem(localStorage, 'searchPreference'));
const commentPreference = JSON.parse(storageGetItem(localStorage, 'commentPreference'))||{};

class DocStore {
  @observable docInfo = {};
  @observable formMessage = null;
  @observable defaultFormHighlight = {
    color:'#DDE4FF',
    colorRequired:'#B1B0FE'
  };
  @observable FormHighlight = {
    color:null,
    colorRequired:null
  };
  @observable commentPreference = Object.assign({isTextAsContent: false, isPopupFloatbar: true}, commentPreference);
  @observable formPreference = !!formPreference?{...formPreference, isAutomatically: true}:{
    FieldsHightLight: "#DDE4FF",
    FieldsHightLight_argb: "0xffDDE4FF",
    FieldsHightLight_clr: {color: "#DDE4FF", rgba: {
      color: "#DDE4FF",
      rgba: {
        a:1
      }
    }},
    HighlightrRequiredFields: "#B1B0FE",
    HighlightrRequiredFields_argb: "0xffB1B0FE",
    HighlightrRequiredFields_clr: {color: "#B1B0FE", rgba: {
      color: "#B1B0FE",
      rgba: {
        a:1
      }
    }},
    isAutomatically: true,
    isHideDocumentMessage: false,
    isHighlight: true,
    isNumericalData: false,
    isOpenPropertiesAfterCreating: true,
    isOverflowIndicator: false,
    isRectangle: true,
    isRunFormRecognition: false,
    isRememberNumerical:false,
    isAutoComplete:'off'
  }
  @observable layoutPreference =!!layoutPreference?layoutPreference: {
    WidthBetweenLines:"1.000",
    HeightBetweenLines:"1.000",
    GridOffsestFromLeftEdge:"1.000",
    GridOffsestFromTopEdge:"1.000",
    Subdivisions:"3",
    GridLineColcor:"#1e43d6",
  }
  @observable searchPreference = !!searchPreference ? searchPreference: {
    isIgnoreAsia: false, 
    isIgnoreDiacritics: false, 
    isAlwaysShowMore: false, 
    RangeOfWord: 900
  }
  @observable isConverted = false;
  @observable docDriveName = '';
  @action setDocDriveName (val){
    this.docDriveName = val;
  }
  @action resetDocDriveName() {
    this.docDriveName = '';
    store.storageAppStore.setCurrentDoc(null);
  }
  @observable compareTemplateIds = {
    newTemplateId: undefined,
    oldTemplateId: undefined,
  }
  @action setIsConverted(val){
    this.isConverted = val;    
  }
  @action insertBlankPage(pageCount, pageIndex, callback) {
    fileController.insertBlankPage(pageCount, pageIndex, callback);
  }
  @action setCurrentDocInfo() {
    fileController.getDocInfo((docInfo) => {
      this.setDocInfo(docInfo);
    });
  }
  @action setDocInfo(docInfo = {}) {
    this.docInfo = docInfo;
    const fileName = docInfo.fileName;
    if (fileName) document.title = fileName;
  }
  @action setFormMessage(msg) {
    this.formMessage = msg;
  }
  @action setFormHightLight({color, colorRequired}){
    this.formPreference.FormHighlight = {
      color,
      colorRequired
    }
  }
  @action setDefaultFormHighlight({color, colorRequired}){
    this.formPreference.defaultFormHighlight = {
      color,
      colorRequired
    }
  }
  @action setIsHideDocumentMessage(value){
    this.formPreference.isHideDocumentMessage = value;
    storageSetItem(localStorage, 'formPreference',JSON.stringify(this.formPreference));

  }
  @action updateFormPreference(key,value){
    this.formPreference[key] = value;
    storageSetItem(localStorage, 'formPreference',JSON.stringify(this.formPreference));

  }
  @action updateFormPreferenceAll(obj){
    this.formPreference = obj;
    storageSetItem(localStorage, 'formPreference', JSON.stringify(this.formPreference));
  }
  @action undateLayoutPreferenceAll(obj){
    this.layoutPreference = obj;
    storageSetItem(localStorage, 'layoutPreference', JSON.stringify(this.layoutPreference));
  }
  @action setAutoRecognitionForm(){
      this.isConverted && this.formPreference.isRunFormRecognition && fileController.autoRecognitionForm()
      this.isConverted = false;
  }
  @action updateSearchPreferenceAll(obj) {
    this.searchPreference = obj;
    storageSetItem(localStorage, 'searchPreference', JSON.stringify(this.searchPreference));
  }
  @action updateCommentPreferenceAll(obj) {
    this.commentPreference = obj;
    storageSetItem(localStorage, 'commentPreference', JSON.stringify(this.commentPreference));
  }
  @action async getCompareTemplatesFile() {
    const oldUrl = window.location.origin + oldTemplate;
    const newUrl = window.location.origin + newTemplate;
    const newResponse = await fetch(newUrl, {method: 'get',responseType: 'blob'})
    const oldResponse = await fetch(oldUrl, {method: 'get',responseType: 'blob'});
    const newTemplateBlob = await newResponse.blob();
    const oldTemplateBlob = await oldResponse.blob();
    return {
        newTemplateFile: newTemplateBlob,
        oldTemplateFile: oldTemplateBlob,
    }
}
  @action async initCompareTemplateDocs() {
    const engine = await window.pdfui.getWebPDFJR();
    const { newTemplateFile, oldTemplateFile } = await this.getCompareTemplatesFile();
    const newTemplateDoc = await engine.getPDFDocByFile(newTemplateFile);
    const oldTemplateDoc = await engine.getPDFDocByFile(oldTemplateFile);
    // 需要调用parse方法
    await newTemplateDoc.parse();
    await oldTemplateDoc.parse();
    return {
      newTemplateId: newTemplateDoc.id,
      oldTemplateId: oldTemplateDoc.id,
   }
  }
  @action async getCompareTemplateDocs() {
    let compareTemplateIds;
    if (this.compareTemplateIds.newTemplateId) {
      compareTemplateIds = this.compareTemplateIds;
    } else {
      compareTemplateIds = await this.initCompareTemplateDocs();
      this.compareTemplateIds = { ...compareTemplateIds };
    }
    return Promise.resolve(compareTemplateIds);
  }
}

export default DocStore
